import { TranslateFn } from "../hooks/useStringTranslation";
import { ProductDetailInterface } from "../interfaces/apiV2/product/ProductDetailInterface";

export interface TransformProductDataParams {
    data: ProductDetailInterface;
    t: TranslateFn;
}

interface ProductInfoBarData {
    name: string;
    identifier: string;
    breadcrumbs: Array<{ label: string }>;
    labels: {
        identifier: string;
        requestButton: string;
        downloadButton: string;
        requestSubject: string;
    };
}

export const transformProductInfoBarData = ({
    data,
    t,
}: TransformProductDataParams): ProductInfoBarData => {
    const name = data.label;

    const breadcrumbs: Array<{ label: string }> = [];

    if (data.categories[0]?.label) {
        breadcrumbs.push({ label: data.categories[0].label });
    }

    if (data.productFamily?.label) {
        breadcrumbs.push({ label: data.productFamily.label });
    }

    breadcrumbs.push({ label: name });

    const labels = {
        identifier: t("art-nr"),
        requestButton: t("request-information"),
        downloadButton: t("download-productsheet"),
        requestSubject: t("request-information-subject"),
    };

    return {
        name,
        identifier: data.identifier,
        breadcrumbs,
        labels,
    };
};

export const createMailtoUrl = (
    email: string,
    subject: string,
    productName: string,
): string => {
    return `mailto:${email}?subject=${subject} ${productName}`;
};
